import React from 'react'
import { Message, Container } from 'semantic-ui-react'

const ErrorContainer = ({ error }) => {
    return (
        <Container style={{ marginTop: '20px' }}>
            <Message error>
                <Message.Header>Pihkura sentään!</Message.Header>
                {error}
            </Message>
        </Container>
    )
}

export default ErrorContainer


// WEBPACK FOOTER //
// ./src/Shared/ErrorContainer.js